"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { CircleCheck as CheckCircle2, MonitorSmartphone, User } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const providedInfo = ["Name", "Address", "Telephone number", "Email address", "Property details relevant to the services requested", "Payment and billing information", "Correspondence and communications with us"];
const automaticInfo = ["IP address", "Browser type and version", "Device information", "Website usage data", "Cookies and similar technologies"];
export default function InformationWeCollect() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="informationwecollect" className="bg-background py-16 md:py-24 font-sans">
      <div className="container mx-auto px-4 max-w-4xl" ref={ref}>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="space-y-8">
          <div className="text-center md:text-left space-y-4 mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground font-default">
              {"3. Information We Collect"}
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl">
              {"We may collect and process the following personal information when you interact with our services or website."}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            <Card className="h-full shadow-md border-border/50">
              <CardHeader className="pb-4">
                <CardTitle className="flex items-center gap-3 text-xl font-default text-foreground">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <User className="w-5 h-5 text-primary" />
                  </div>
                  {"Information You Provide"}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3">
                  {providedInfo.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-muted-foreground">
                      <CheckCircle2 className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                      <span className="leading-relaxed">{item}</span>
                    </li>)}
                </ul>
              </CardContent>
            </Card>

            <Card className="h-full shadow-md border-border/50">
              <CardHeader className="pb-4">
                <CardTitle className="flex items-center gap-3 text-xl font-default text-foreground">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <MonitorSmartphone className="w-5 h-5 text-primary" />
                  </div>
                  {"Information We Collect Automatically"}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-muted-foreground">
                  {"If you visit our website, we may collect:"}
                </p>
                <ul className="space-y-3">
                  {automaticInfo.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-muted-foreground">
                      <CheckCircle2 className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                      <span className="leading-relaxed">{item}</span>
                    </li>)}
                </ul>
              </CardContent>
            </Card>
          </div>
        </motion.div>
      </div>
    </section>;
}